<template>
  <v-form ref="modTextAreaForm" v-model="formValid" @submit.prevent v-if="existing">
    <v-list-item v-if="!editField">
      <v-list-item-content>
        <v-list-item-subtitle v-html="label" />
        <v-chip-group column>
          <v-chip
            v-if="existing.length === 0"
            label
            outlined
            small
            color="grey"
            disabled
            v-html="`No Associated ${label}`" />
          <v-chip
            v-else
            v-for="chip in existing"
            :key="`${label}.${chip.id}`"
            link
            label
            outlined
            small
            color="white">
            {{ prefix }}{{ chip[shorttext] }}
          </v-chip>
        </v-chip-group>
      </v-list-item-content>
      <v-list-item-icon>
        <v-btn icon small @click="editField = true" title="Edit Field">
          <v-icon small color="warning" v-text="mdiPencilOutline" />
        </v-btn>
      </v-list-item-icon>
    </v-list-item>
    <v-list-item v-else>
      <v-list-item-content dense>
        <v-autocomplete
          v-model="newMappings"
          :items="options"
          hide-selected
          hide-no-data
          item-value="id"
          :item-text="longtext"
          placeholder="Start typing to search"
          @change="checkList"
          return-object
          multiple
          clearable
          chips
          color="dw_green"
        >
          <template v-slot:label>
            <div v-html="`Edit ${label}`"></div>
          </template>
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="removeMapping(data.item)"
              color="dw_green"
              outlined
              small
            >
              {{ prefix }}{{ data.item[shorttext] }}
            </v-chip>
          </template>
          <template v-slot:item="data">
            <template v-if="(typeof data.item !== 'object')">
              <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-content>
                <v-list-item-title v-html="data.item[longtext]"></v-list-item-title>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
        <div class="d-flex pt-1">
          <v-btn
            type="button"
            @click="resetField"
            outlined
            x-small
            color="red">
            <v-icon x-small color="red" class="mr-1" v-text="mdiClose" />
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            type="button"
            :disabled="!listChanged"
            @click="updateField"
            outlined
            x-small
            color="dw_green">
            <v-icon x-small color="dw_green" class="mr-1" v-text="mdiContentSaveOutline" />
            Save
          </v-btn>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-form>
</template>

<script>
import { mdiContentSaveOutline, mdiPencilOutline, mdiClose } from '@mdi/js';
import { mapActions } from 'vuex';
import utils from '@/utils/index';

export default {
  name: 'moderateSelectChips',
  props: ['existingIDs', 'options', 'label', 'prefix', 'shorttext', 'longtext'],
  data() {
    return {
      mdiContentSaveOutline,
      mdiPencilOutline,
      mdiClose,
      editField: false,
      formValid: false,
      existing: [],
      newMappings: [],
      listChanged: false
    }
  },
  watch: {
    editField() {
      if (this.editField) {
        this.setChipsList();
      }
    },
    existingIDs() {
      this.setChipsList();
    }
  },
  mounted() {
    this.setChipsList();
  },
  methods: {
    setChipsList() {
      const chips = this.existingIDs.map((id) => {
        const isSelected = this.options.find((opt) => opt.id === id);
        return isSelected;
      });
      this.existing = chips;
      this.newMappings = chips;
      this.$forceUpdate();
    },
    removeMapping(item) {
      this.newMappings = this.newMappings.filter((chip) => chip.id !== item.id);
      this.checkList();
    },
    checkList() {
      let existing = [...this.existingIDs];
      existing = existing.sort();
      existing = existing.join(', ');
      let updated = this.newMappings.map((chip) => chip.id);
      updated = updated.sort();
      updated = updated.join(', ');
      if (updated === existing) this.listChanged = false;
      else this.listChanged = true;
    },
    updateField() {
      const ids = this.newMappings.map((chip) => chip.id);
      this.$emit('saveChanges', ids);
      this.editField = false;
    },
    resetField() {
      this.editField = false;
    }
  }
};
</script>
